import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d3d8872"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "empty-order-layout" }
const _hoisted_2 = { class: "empty-message" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "in-catalog-btn__image" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "in-catalog-btn__text" }, " Перейти в каталог ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "in-catalog-btn__triangle" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode(_component_router_link, {
      to: { name: 'company' },
      class: "in-catalog-btn"
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5
      ]),
      _: 1
    })
  ]))
}